import { lazy } from 'react';
import { SidebarLayout } from '@trukt/ui/SidebarLayout';
import { PageTitle } from '@trukt/ui/PageTitle';
import { RouteObject } from 'react-router-dom';

import { PATH_NAMES } from '../../shared';
import { SidebarContainer } from '../../components';
import { ORDER_STATUS_MAP } from '@trukt/utils/OrderStatusMap';

const OrderListView = lazy(() => import('../../OrderListView'));

export const REPORT_ROUTES: RouteObject[] = [
  {
    path: PATH_NAMES.ROOT,
    element: (
      <PageTitle>
        <SidebarLayout sidebar={<SidebarContainer />} />
      </PageTitle>
    ),
    children: [
      {
        path: `${PATH_NAMES.reports.VIEW}/:reportGuid`,
        element: <OrderListView status={ORDER_STATUS_MAP.ALL} key="reports" />,
      },
    ],
  },
];
